import { Directive } from "@angular/core";
import { BaseComponent, UserService } from "@mypxplat/xplat/core";

@Directive()
export abstract class FeatureUpdatesBaseComponent extends BaseComponent {
  public text: string = "FeatureUpdates";

  constructor(userService: UserService) {
    super(userService);
  }
}
